import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import OnDemand from "../../../assets/img/Featured/app-ondemand-food-tall.png";
import SmartMenu from "../../../assets/img/Featured/app-order-menu-tall.png";
import QuickPay from "../../../assets/img/Featured/app-qr-quickpay-tall.png";
import DigitalMenu from "../../../assets/img/Featured/digital-menu.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const DiningRoomPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page diningRoomPage">
        <Header />
        <div className="page-header">On Site Dining</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Dining Room</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Keep staff informed of residents’ seating choices, food preferences,
            allergies, personal celebrations, and more.{'\n\n'}
            
            Technology enables fast, fresh, convenient delivery of food, 
            while supporting rotating and flexible menus.{'\n\n'}

            Grab-and-go food and beverage options include
            mobile barcode scanning with advanced self-service check-out.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Dining - Dining Room", "InfoGenesis");
              addFlow("InfoGenesis");
              navigate("/solutions/info-genesis");
            }}
          >
            <div className="item-head">
              <LogoMini />
              InfoGenesis
            </div>
            <img src={InfoGenesis} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Dining - Dining Room", "IG OnDemand");
              addFlow("IG On Demand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={OnDemand} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Dining - Dining Room", "IG Smart Menu");
              addFlow("IG Smart Menu");
              navigate("/solutions/ig-smart-menu");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Smart Menu
            </div>
            <img src={SmartMenu} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Dining - Dining Room", "IG Quick Pay");
              addFlow("IG Quick Pay");
              navigate("/solutions/ig-quick-pay");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Quick Pay
            </div>
            <img src={QuickPay} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Dining - Dining Room", "IG Digital Menu Board");
              addFlow("IG Digital Menu Board");
              navigate("/solutions/digital-menu");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Digital Menu Board
            </div>
            <img src={DigitalMenu} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default DiningRoomPage;